<script lang="ts">
  let { label, accept, onfile, testid }: { label: string; accept: string; onfile: (f: File) => void; testid?: string } =
    $props();
  let input: HTMLInputElement;
  let over = $state(false);
</script>

<div
  class="drop"
  class:over
  role="button"
  tabindex="0"
  ondragover={(e) => {
    e.preventDefault();
    over = true;
  }}
  ondragleave={() => (over = false)}
  ondrop={(e) => {
    e.preventDefault();
    over = false;
    const f = e.dataTransfer?.files?.[0];
    if (f) onfile(f);
  }}
  onclick={() => input.click()}
  onkeydown={(e) => (e.key === 'Enter' || e.key === ' ') && input.click()}
>
  {label}
  <input
    bind:this={input}
    type="file"
    {accept}
    hidden
    data-testid={testid}
    onchange={(e) => {
      const f = (e.currentTarget as HTMLInputElement).files?.[0];
      if (f) onfile(f);
      (e.currentTarget as HTMLInputElement).value = '';
    }}
  />
</div>

<style>
  .drop {
    border: 1px dashed var(--line);
    border-radius: var(--radius);
    padding: 14px 10px;
    text-align: center;
    color: var(--muted);
    cursor: pointer;
    font-size: 13px;
    transition:
      border-color 0.15s,
      color 0.15s;
  }
  .drop:hover,
  .drop.over {
    border-color: var(--accent);
    color: var(--text);
  }
</style>
